import { render, staticRenderFns } from "./configurationPassCard.vue?vue&type=template&id=4e237ff8&scoped=true&"
import script from "./configurationPassCard.vue?vue&type=script&lang=js&"
export * from "./configurationPassCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e237ff8",
  null
  
)

export default component.exports